import React from 'react';
import { InstanceProvider, ThemeProvider } from '@stepstone-genesis/components';
import { coretwentyfive } from '@stepstone-genesis/dresscode';
import { widgetStyleInstance } from './sharedInstance';
export const AppProviders = ({ children, theme, isAMAEnabled }) => {
    const cache = React.useMemo(() => widgetStyleInstance.createCache(), []);
    // Use coretwentyfive theme when AMA is enabled, otherwise use site-specific theme
    const activeTheme = isAMAEnabled ? coretwentyfive : theme;
    return (React.createElement(InstanceProvider, { instance: widgetStyleInstance, cache: cache },
        React.createElement(ThemeProvider, { theme: activeTheme }, children)));
};
